exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.mp-filter-menu .mp-filter-menu-header {\n  border-bottom: 1px solid var(--component-outline-color);\n  display: none;\n}\n.mp-filter-menu .mp-filter-menu-header.is-visible {\n  display: flex;\n}\n.mp-filter-menu mp-select.mp-filter-menu-cohort-options {\n  flex: 1;\n  margin: 8px;\n}\n", ""]);

// exports
